import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
import "./otp.css"
$(document).ready(function() {
    const $in = document.getElementById("phonenum")
    if($in){
       intlTelInput($in, {
      initialCountry: "auto",
      separateDialCode: true,
      geoIpLookup: function (callback) {
        $.getJSON("https://ipapi.co/json", function (data) {
          var countryCode =
            data && data.country_code ? data.country_code : "us";
          callback(countryCode);
        });
      },
      customContainer: "d-flex mt-2",
    });
    }

});